import Vue from 'vue'

/**
 * Per-KVM-service feature flags that live outside the server view, so the
 * shared ServiceSidebar (which knows nothing about individual servers) can show
 * menu items only where they apply. KvmServiceView fills this in from /service
 * each time it loads a server; menu items opt in with `requiresFeature`.
 */
export const kvmFeatures = Vue.observable({
  docker: {}, // hostingid → true when the service offers the Docker Manager
})

export function setKvmFeature (feature, hostingid, enabled) {
  if (!hostingid || !kvmFeatures[feature]) return
  Vue.set(kvmFeatures[feature], String(hostingid), !!enabled)
}

export function hasKvmFeature (feature, hostingid) {
  return !!(kvmFeatures[feature] && kvmFeatures[feature][String(hostingid)])
}
